import React from 'react';
import {Typography} from '@mui/material';
import '../../../StandardReports.scss';
import {ReactComponent as InfoIcon} from '../../../../../../assets/images/info-icon.svg';
import ArrTooltipWrapper from '../../../../../common/arr-tooltip-wrapper/ArrTooltipWrapper';

type FilterHeaderProps = {
  title: string;
  showInfoIcon?: boolean;
  classname?: string;
  tooltipText?: string;
  tooltipTitle?: string;
  forceInLineToolTip?: boolean;
  isRequired?: boolean;
};

const FilterHeader: React.FC<FilterHeaderProps> = ({
  title,
  showInfoIcon,
  classname,
  tooltipText,
  tooltipTitle,
  forceInLineToolTip = false,
  isRequired,
}) => {
  const renderInfoIcon = () => {
    if (showInfoIcon && tooltipText) {
      return (
        <ArrTooltipWrapper
          title={tooltipTitle || tooltipText}
          placement="top"
          trigger={
            <InfoIcon
              data-testid="info-icon"
              className="info-icon"
              tabIndex={0}
            />
          }
          forceInLineToolTip={forceInLineToolTip}
        >
          {!forceInLineToolTip ? (
            tooltipText
          ) : (
            <div
              dangerouslySetInnerHTML={{__html: tooltipText}}
              data-testid={`filter-header-inner-html`}
            ></div>
          )}
        </ArrTooltipWrapper>
      );
    }
    if (showInfoIcon) {
      return <InfoIcon data-testid="info-icon" className="info-icon" />;
    }
    return null;
  };
  return (
    <div
      className="selection-criteria-header"
      data-testid={`filter-header-wrapper-${title}`}
    >
      <Typography
        className={`${classname} typo-text selection-criteria-title subhead3_size`}
        tabIndex={0}
        data-testid={`filter-header-title-${title}`}
      >
        {title}
        {isRequired && (
          <span className="asterix" data-testid={`filter-header-`}>
            *
          </span>
        )}
      </Typography>
      {renderInfoIcon()}
    </div>
  );
};

export default FilterHeader;
